import { privateAxios } from '@/services/api'

export const _getHelp = (language) => {
    return privateAxios.get(`/translations/${language}/help`)
        .then(response => response.data)
}
